// eslint-disable-next-line
//Sentry.init({ dsn: 'https://ea77eced91ca450c825a25c7d08ee4c5@sentry.io/1505426' });

// import then needed Font Awesome functionality
import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faTrashAlt, faCalendarAlt, faClock } from '@fortawesome/free-regular-svg-icons';
import { faBars, faAngleRight, faAngleLeft, faAngleDown, faStar, faCaretDown, faPlus, faExternalLinkAlt, faSearch, faTimes, faCheck, faCheckCircle, faPhone, faEnvelope, faSpinner, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faFacebook, faFacebookMessenger, faPinterest, faViber, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
// import external dependencies
import 'jquery';
import 'jquery-custom-select/dist/js/jquery.custom-select';
import '@chenfengyuan/datepicker/dist/datepicker';

// Import everything from autoload

import './util/jquery.debounce';
import initMap from './util/maps.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import career from './routes/career';
import reviews from './routes/reviews';
import templateBooking from './routes/template-booking.jsx';
import templateVouchers from './routes/gift-vouchers.jsx';
import taxServices from './routes/tax-services';
import contacts from './routes/contacts';
import singleProduct from './routes/singleProduct';
import templateShopLanding from './routes/template-shop-landing';

import Storage from './util/Storage';
import uuidv4 from './util/uuid';

(function($) {
    window.initMap = initMap;

    if (!Storage.getItem(Storage.KEY_UNIQUE_USER_ID)) {
        Storage.setItem(Storage.KEY_UNIQUE_USER_ID, uuidv4());
    }

    config.searchPseudoElements = true;

    // add the imported icons to the library
    library.add(faTrashAlt, faCalendarAlt, faClock, faBars, faAngleRight, faAngleLeft, faAngleDown, faStar, faCaretDown, faPlus, faExternalLinkAlt,
      faSearch, faTimes, faCheck, faCheckCircle, faPhone, faEnvelope, faSpinner, faCircleNotch, faInstagram,
        faFacebook, faFacebookMessenger, faPinterest, faViber, faWhatsapp);

    // tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
    dom.watch();

    /** Populate Router instance with DOM routes */
    const routes = new Router({
      // All pages
      common,
      // Home page
      home,
      // About Us page, note the change from about-us to aboutUs.
      aboutUs,
      career,
      templateBooking,
      templateVouchers,
      contacts,
      reviews,
      taxServices,
      singleProduct,
      templateShopLanding,
    });

    // Load Events
    $(document).ready(() => routes.loadEvents());
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/main.js